<template>
    <div>
        <div v-if="!show && type !== 'html'">
            <span :class="textClass">{{ truncate(text) }}</span>
            <button
                type="button"
                v-if="isExpandable && text.length >= length"
                :class="actionClass"
                @click="toggle()"
            >{{ clamp }}</button>
        </div>
        <div v-else-if="!show && type === 'html'">
            <span :class="textClass" v-html="truncate(text)"></span>
            <button
                type="button"
                v-if="isExpandable && text.length >= length"
                :class="actionClass"
                @click="toggle()"
            >{{ clamp }}</button>
        </div>
        <div v-if="show && type !== 'html'">
            <span>{{ text }}</span>
            <button
                type="button"
                v-if="isExpandable && text.length >= length"
                :class="actionClass"
                @click="toggle()"
            >{{ less }}</button>
        </div>
        <div v-else-if="show && type === 'html'">
            <div v-if="text.length >= length" v-html="text"></div>
            <button
                type="button"
                v-if="isExpandable && text.length >= length"
                :class="actionClass"
                @click="toggle()"
            >{{ less }}</button>
            <p v-else>{{ htmlTruncate(text) }}</p>
        </div>
    </div>
</template>
<script>
import htmlTruncate from 'html-truncate'
export default {
    name: 'Truncate',
    props: {
        collapsedTextClass: {type: String, default: ''},
        text: {type: String, required: true},
        clamp: {type: String, default: 'Read More'},
        length: {type: Number, default: 100},
        less: {type: String, default: 'Show Less'},
        type: {type: String, default: 'text'},
        actionClass: {type: String, default: ''},
        isExpandable: {type: Boolean, default: true}
    },
    data: () => ({
        show: false
    }),
    computed: {
        textClass() {
            return (this.text.length > this.length && this.collapsedTextClass) ? this.collapsedTextClass : '';
        }
    },
    methods: {
        truncate(string) {
            let result = '';
            if (string) {
                result = this.type === 'html'
                    ? htmlTruncate(string, this.length)
                    : string.toString().substring(0, this.length);
            }
            return result;
        },
        toggle() {
            const toggled = !this.show;
            this.show = toggled;
            this.$emit('toggle', toggled);
        },
        htmlTruncate(text) {
            return htmlTruncate(text);
        }
    }
};
</script>
